import { applyMiddleware, createStore } from 'redux'
import promise from 'redux-promise'
import logger from 'redux-logger'
import reducer from './reducer'

const middlewares = applyMiddleware(promise, logger)
const store = createStore(reducer, middlewares)
window.store = store

export default store



// WEBPACK FOOTER //
// ./src/store/index.js